import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Deck from "@/pages/Deck";
import Inbox from "@/pages/Inbox";
import Admin from "@/pages/Admin";
import AdminProspectDetail from "@/pages/AdminProspectDetail";
import AdminLeads from "@/pages/AdminLeads";
import AdminEditPortfolio from "@/pages/AdminEditPortfolio";
import AdminEditCore from "@/pages/AdminEditCore";
import ProspectGate from "@/pages/ProspectGate";
import TrustPage from "@/pages/TrustPage";
import { me } from "@/lib/api";

function ProtectedRoute({ children, requireScope }) {
  const [state, setState] = useState({ loading: true, authed: false, scope: null });
  useEffect(() => {
    (async () => {
      try {
        const r = await me();
        setState({ loading: false, authed: !!r.authenticated, scope: r.scope });
      } catch {
        setState({ loading: false, authed: false, scope: null });
      }
    })();
  }, []);
  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-900 text-cream">
        <div className="mono text-sm opacity-60">authenticating…</div>
      </div>
    );
  }
  if (!state.authed) return <Navigate to="/login" replace />;
  if (requireScope && state.scope !== requireScope) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/trust" element={<TrustPage />} />
          <Route path="/p/:slug" element={<ProspectGate />} />
          <Route path="/p/:slug/plan/:planId" element={<ProspectGate />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Deck />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inbox"
            element={
              <ProtectedRoute requireScope="master">
                <Inbox />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requireScope="master">
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/prospects/:id"
            element={
              <ProtectedRoute requireScope="master">
                <AdminProspectDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/leads"
            element={
              <ProtectedRoute requireScope="master">
                <AdminLeads />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/edit/portfolio"
            element={
              <ProtectedRoute requireScope="master">
                <AdminEditPortfolio />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/edit/core"
            element={
              <ProtectedRoute requireScope="master">
                <AdminEditCore />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-center" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
